import { useGqlQuery } from '@API/useAvQuery';
import { QueryKey } from '@fabric-ui/utils';
import { gql } from 'graphql-request';

const GET_SCHEDULE_EXPORT_REPORT_PERMISSIONS = gql`
  query isPermittedDashboardReportForUser($id: String!) {
    isPermittedDashboardReportForUser(id: $id)
  }
`;

export const getScheduleExportReportPermissions = ({ reportId, enabled }: { reportId: string | undefined; enabled: boolean }) =>
  useGqlQuery({
    queryKey: [QueryKey.ScheduleExportReportPermissions],
    query: GET_SCHEDULE_EXPORT_REPORT_PERMISSIONS,
    variables: { id: reportId },
    enabled,
    select: (isPermittedDashboardReportForUser: boolean) => isPermittedDashboardReportForUser,
  });
